// socketSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  socketId: null,
  connected: false,
  pendingEvents: [],
};

const socketSlice = createSlice({
  name: "socket",
  initialState,
  reducers: {
    setConnected: (state, action) => {
      state.connected = true;
      state.socketId = action.payload.socketId;
    },
    setDisconnected: (state) => {
      state.connected = false;
      state.socketId = null;
    },
    queueEvent: (state, action) => {
      state.pendingEvents.push(action.payload);
    },
    flushEvents: (state) => {
      state.pendingEvents = [];
    },
    
  },
});

export const { setConnected, setDisconnected, queueEvent, flushEvents } =
  socketSlice.actions;

export default socketSlice.reducer;
